export const RewardListDescription = ({ rewards }: { rewards: string[] }) => {
  return (
    <div className="bg-back200 text-text400 mt-[6px] flex h-32 flex-col justify-between overflow-auto rounded-[10px] px-4 py-5 font-normal">
      {rewards.map((reward) => (
        <div className="pb-3 text-xs last:pb-0" key={reward}>
          <span className="bg-indentPoint mr-[10px] inline-block h-[7px] min-w-[7px] rounded" />
          <span className="break-keep leading-5">{reward}</span>
        </div>
      ))}
    </div>
  );
};
